import { useConfig } from '@@/common/services/useConfig';

import ErrorBoundaryView from './ErrorBoundaryView';

export default function ErrorBoundaryViewForTenant() {
  const {
    config: { errorBoundaryConfig, errorPageConfig },
  } = useConfig();

  return (
    <ErrorBoundaryView
      errorBoundaryConfig={errorBoundaryConfig}
      errorPageConfig={errorPageConfig}
    />
  );
}
